import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@mui/material';
import { ActionIcons } from '../../../../../../Iconography';
import { commonButtonProps } from './common';
const debug = process.env.REACT_APP_DEBUG && false;
export const getSaveButton = ({ edited, disabled, loading, handleSaveObject, hasValidationErrors, requiredValuesNotPopulated }) => {
    debug && console.log(`Save button`, { edited, hasValidationErrors, requiredValuesNotPopulated });
    return (_jsx(Button, { ...commonButtonProps,
        startIcon: _jsx(ActionIcons.Save, {}),
        disabled: !edited || disabled || hasValidationErrors || requiredValuesNotPopulated,
        loading,
        onClick: handleSaveObject, children: "Save" }));
};
export const getDeleteButton = ({ handleDelete, disabled, loading, isDeletable }) => {
    return (_jsx(Button, { ...commonButtonProps,
        color: isDeletable ? 'error' : 'warning',
        startIcon: _jsx(ActionIcons.Delete, {}),
        disabled,
        loading,
        onClick: handleDelete, children: "Remove" }));
};
export const getResetButton = ({ edited, disabled, handleCancelEdit }) => {
    return (_jsx(Button, { ...commonButtonProps,
        startIcon: _jsx(ActionIcons.Reset, {}),
        disabled: !edited || disabled,
        onClick: handleCancelEdit, children: "Reset" }));
};
